<template>
  <div
    v-if="product && selectedVariant"
    class="border border-gray-200 p-3 rounded-2xl flex-row space-y-5"
  >
    <div class="flex flex-row items-center">
      <h3 class="text-sm uppercase font-semibold">
        Select Tab Color
      </h3>
      <div class="flex flex-row items-center ml-auto space-x-1">
        <div
          v-for="variant in product.variants"
          :key="variant.id"
        >
          <button
            class="tooltip"
            :class="selectedVariant.id == variant.id && 'selected'"
            @click="selectedVariant = variant"
          >
            <div :class="variant.title.toLowerCase()" />
            <span>{{ variant.title.replace('Shaker Bottle', ' ') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="sale-pointers grid grid-cols-2 gap-3">
      <div class="highlight">
        BPA free
      </div>
      <div class="highlight">
        Fits cup holder
      </div>
      <div class="highlight">
        Powerful snap lid
      </div>
      <div class="highlight">
        Strong & Durable
      </div>
      <div class="highlight">
        Convenient fill line
      </div>
      <div class="highlight">
        Dishwasher Safe
      </div>
    </div>
    <add-to-cart-button
      :variant="selectedVariant"
      :gtm-label="`${product.title} - ${selectedVariant.title}`"
      @click="$cart.add(product, selectedVariant)"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useProductsStore } from '@/stores'
import { getTemplateData } from '@/utils'
import type { Variant } from '@/types/shopify'
import AddToCartButton from '@/components/shared/add-to-cart-button.vue'
import { storeToRefs } from 'pinia'
const store = useProductsStore()
const { product } = storeToRefs(store)
const selectedVariant = ref<Variant | undefined>()
store.product = getTemplateData('#json-product')
selectedVariant.value = product.value?.variants?.[0]
</script>
